import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var isValidToken = function isValidToken() {
  var expiresAt = Number(localStorage.getItem('MDM_ACCESS_TOKEN_EXPIRES_AT'));
  return !!(localStorage.getItem('MDM_ACCESS_TOKEN') && new Date().getTime() < expiresAt);
};

export default isValidToken;